import { AssetSearch } from '@gripp/shared-ui';

interface AssetSearchModalProps {
  isVisible: boolean;
  onDismiss: () => void;
}

export const AssetSearchModal = ({ isVisible, onDismiss }: AssetSearchModalProps) => (
  <AssetSearch mode="modal" isVisible={isVisible} onDismiss={onDismiss} />
);
